import {
  Component,
  OnInit,
  ViewChild,
  Input,
  OnDestroy,
  Host,
  Inject,
  ChangeDetectorRef,
  Output,
  EventEmitter
} from '@angular/core';
import { ANNOTATIONS } from '@angular/core/src/util/decorators';
import {
  MatDatepicker,
  DateAdapter,
  MAT_DATE_FORMATS,
  MatCalendar,
  MatDateFormats
} from '@angular/material';
import { Proceso, Mes, Empresa } from '../../classes/coordinador';
import { AppDateAdapter, APP_DATE_FORMATS } from '../../shared/date.adapters';
import { ChangeDetectionStrategy } from '@angular/compiler/src/core';
import { Subject } from 'rxjs';
import { isDefined } from '@angular/compiler/src/util';
import { FechaService } from 'src/app/shared/services/fecha.service';

@Component({
  selector: 'app-filtros',
  templateUrl: './filtros.component.html',
  styleUrls: ['./filtros.component.css'],
  providers: [
    MatCalendar,
    {
      provide: DateAdapter,
      useClass: AppDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS
    }
  ]
})
export class FiltrosComponent implements OnInit {
  constructor(private fechaService: FechaService) {}

  filtrosSeleccionados: {
    proceso: Proceso;
    empresa: Empresa;
    anno: number;
    mes: Mes;
    plazoCargaEmpresa: any;
    abierto: boolean;
  };

  minDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  maxDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);

  @Input()
  procesos: Proceso[];

  @Input()
  empresas: Empresa[];

  @Input()
  plazoMaximo: boolean;

  @Output()
  hayCambios: EventEmitter<any> = new EventEmitter();

  filtros: {
    procesos: Proceso[];
    annos: number[];
    meses: Mes[];
  };

  empresaFiltro;
  procesoFiltro;
  procesoAux: any = 'sin_proceso';

  ngOnInit() {
    this.inicializarFiltros();
    this.cargarAnnos();
    this.cargarMeses();
    this.seleccionarMesAnterior();
  }

  seleccionarMesAnterior() {
    for (const mes of this.filtros.meses) {
      const mesActual = new Date().getMonth();
      if (mes.numero === mesActual) {
        this.filtrosSeleccionados.mes = mes;
        return;
      }
    }
  }

  inicializarFiltros() {
    this.filtros = {
      procesos: [],
      annos: [],
      meses: []
    };
    this.filtrosSeleccionados = {
      proceso: undefined,
      empresa: undefined,
      anno: undefined,
      mes: undefined,
      plazoCargaEmpresa: undefined,
      abierto: undefined
    };
    this.filtrosSeleccionados.anno = new Date(
      new Date().getFullYear(),
      new Date().getMonth() - 1,
      1
    ).getFullYear();
  }

  public cargarFechas(
    plazoMaximoCoordinador?,
    plazoMaximoEmpresa?,
    procesoAbierto?
  ) {
    if (
      plazoMaximoEmpresa &&
      plazoMaximoCoordinador &&
      isDefined(procesoAbierto)
    ) {
      // yyyy-MM-dd
      this.filtrosSeleccionados.plazoCargaEmpresa = new Date(
        plazoMaximoEmpresa.replace(/-/g, '/')
      );
      this.filtrosSeleccionados.abierto = procesoAbierto;
    } else {
      this.filtrosSeleccionados.plazoCargaEmpresa = this.fechaService.getFechaMaxima(
        this.filtrosSeleccionados.proceso.diaHabilEmpresa,
        this.filtrosSeleccionados.proceso.diaMaximoEmpresa,
        this.filtrosSeleccionados.anno,
        this.filtrosSeleccionados.mes.numero
      );

      this.filtrosSeleccionados.abierto = undefined;
    }
  }

  cargarAnnos() {
    const primerAnno = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + -1,
      1
    ).getFullYear();

    for (let i = primerAnno; i > primerAnno - 10 && i >= 2018; i--) {
      this.filtros.annos.push(i);
    }
  }

  emitirCambio() {
    this.hayCambios.emit(true);
  }

  cargarMeses() {
    this.filtrosSeleccionados.mes = undefined;

    this.filtros.meses = [
      {
        nombre: 'Enero',
        sigla: 'Ene',
        numero: 1,
        bloqueado: false
      },
      {
        nombre: 'Febrero',
        sigla: 'Feb',
        numero: 2,
        bloqueado: false
      },
      {
        nombre: 'Marzo',
        sigla: 'Mar',
        numero: 3,
        bloqueado: false
      },
      {
        nombre: 'Abril',
        sigla: 'Abr',
        numero: 4,
        bloqueado: false
      },
      {
        nombre: 'Mayo',
        sigla: 'May',
        numero: 5,
        bloqueado: false
      },
      {
        nombre: 'Junio',
        sigla: 'Jun',
        numero: 6,
        bloqueado: false
      },
      {
        nombre: 'Julio',
        sigla: 'Jul',
        numero: 7,
        bloqueado: false
      },
      {
        nombre: 'Agosto',
        sigla: 'Ago',
        numero: 8,
        bloqueado: false
      },
      {
        nombre: 'Septiembre',
        sigla: 'Sep',
        numero: 9,
        bloqueado: false
      },
      {
        nombre: 'Octubre',
        sigla: 'Oct',
        numero: 10,
        bloqueado: false
      },
      {
        nombre: 'Noviembre',
        sigla: 'Nov',
        numero: 11,
        bloqueado: false
      },
      {
        nombre: 'Diciembre',
        sigla: 'Dic',
        numero: 12,
        bloqueado: false
      }
    ];

    if (new Date().getFullYear() === this.filtrosSeleccionados.anno) {
      const mesActual = new Date().getMonth() + 1;
      for (const mes of this.filtros.meses) {
        mes.bloqueado = mes.numero >= mesActual;
      }
    }
  }
}
